import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as dayjs from 'dayjs';
import { CustomTableComponent } from '@frontend/shared';
import { Store } from '@ngrx/store';
import { AdminState, getSuccess, UpdateContentStatus } from '@frontend/admin-store';
import { Router, ActivatedRoute } from '@angular/router';
import { ContentsList, getContentsList } from '@frontend/admin-store';
import { select } from '@ngrx/store';
import { BsModalService } from 'ngx-bootstrap/modal';
import { UpdateContentStatusComponent } from './update-contents-status/update-contents-status.components';

@Component({
  selector: 'frontend-content',
  templateUrl: './contents.components.html',
  styleUrls: ['./contents.components.scss']
})
export class ContentsComponents implements OnInit {
  currentUser: any;
  submitted = false;
  unsubscriber = new Subject();
  filter: UntypedFormGroup;
  content_types: any[] = [
    {
      name: 'Video',
      id: 'video'
    },
    {
      name: 'Podcast Episodes',
      id: 'podcast_episode'
    },
    {
      name: 'Track',
      id: 'track'
    }
  ];
  statusOptions: any[] = [
    {
      name: 'Active',
      id: 'active'
    },
    {
      name: 'Inactive',
      id: 'inactive'
    }
  ];
  month: any[] = [
    {
      name: 'Current Week',
      id: `${dayjs().startOf('week').format('YYYY-MM-DD')}/${dayjs().format('YYYY-MM-DD')}`
    },
    {
      name: 'Current Month',
      id: `${dayjs().startOf('month').format('YYYY-MM-DD')}/${dayjs().format('YYYY-MM-DD')}`
    },
    {
      name: 'Last 30 days',
      id: `${dayjs().subtract(30, 'days').format('YYYY-MM-DD')}/${dayjs().format('YYYY-MM-DD')}`
    },
    {
      name: 'Last 6 month',
      id: `${dayjs().subtract(6, 'month').format('YYYY-MM-DD')}/${dayjs().format('YYYY-MM-DD')}`
    },
    {
      name: 'Last 12 Months',
      id: `${dayjs().subtract(12, 'month').format('YYYY-MM-DD')}/${dayjs().format('YYYY-MM-DD')}`
    }
  ];
  customDatatableSettings: any = {};
  currentPage = 1;
  itemsPerPage = 10;
  timeout: any = null;
  searchText: any = '';
  contents: any = [];
  searchData = '';
  queryParams: any = {};
  isStatusAction = false;
  // sort: any = {};
  @ViewChild('customTableComponent', { static: true }) customTableComponent: CustomTableComponent;

  constructor(
    private adminStore: Store<AdminState>,
    private formBuilder: UntypedFormBuilder,
    private activeRoute: ActivatedRoute,
    private modelService: BsModalService,
    private router: Router
  ) {
    this.filter = this.formBuilder.group({
      fromDate: [null, [Validators.required]],
      toDate: [null, [Validators.required]],
      monthRange: [`${dayjs().subtract(30, 'days').format('YYYY-MM-DD')}/${dayjs().format('YYYY-MM-DD')}`, [Validators.required]],
      content_type: ['video', [Validators.required]],
      status: ['active', [Validators.required]]
    });
    this.subscribeToStore();

    this.activeRoute.queryParams.subscribe(query => {
      this.queryParams = {
        page: parseInt(query.page || 1),
        limit: 10,
        search: query.search || '',
        monthRange: query.monthRange || `${dayjs().subtract(30, 'days').format('YYYY-MM-DD')}/${dayjs().format('YYYY-MM-DD')}`,
        content_type: query.content_type || 'video',
        status: query.status || 'active'
        // sort: query.sort ||  {field: 'streams', dir: "desc"}
      };
      this.searchData = query.search || '';
      // this.sort = query.sort ? JSON.parse(query.sort) : {}
      this.callApi();
    });
  }

  ngOnInit(): void {
    this.customDatatableSettings = {
      paging: true,
      withPage: true,
      serverSide: true,
      columns: [{ data: null }, { data: null }, { data: null }, { data: null }, { data: null }, { data: null }],
      addAjax: true,
      searching: false
      // orderColumns: ['creator', 'author', 'views', 'streams', 'createdAt'],
      // order: [[2, 'desc']],
    };
  }

  subscribeToStore() {
    this.adminStore.pipe(select(getContentsList))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(distributeTokens => {
        if (distributeTokens) {
          this.contents = distributeTokens.data;
          if (this.customTableComponent?.ajaxCallback) {
            this.customTableComponent?.ajaxCallback({
              recordsTotal: distributeTokens.count.total,
              recordsFiltered: distributeTokens.count.total,
              data: []
            });
            setTimeout(() => {
              this.customTableComponent?.reAdjustColumnsInTable();
            }, 500);
          }
        } else {
          this.contents = [];
        }
      });

    this.adminStore.pipe(select(getSuccess))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(success => {
        if (success) {
          if (this.isStatusAction) {
            this.isStatusAction = false;
            this.callApi();
          }
        }
      });
  }

  search(event: any) {
    if (event) {
      let searchValue = event.target.value;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        searchValue = searchValue.trim();
        this.searchText = searchValue;
        this.router.navigate(['/contents'], {
            queryParams: {
              ...this.queryParams,
              search: searchValue
            },
            queryParamsHandling: 'merge'
          }
        );
      }, 1500);
    }
  }

  filterMonthRangeData(page: any = {}) {
    if (page?.page) {
      this.currentPage = page?.page;
    }
    this.router.navigate(['/contents'], {
        queryParams: {
          ...this.queryParams,
          monthRange: this.filter.value.monthRange
        },
        queryParamsHandling: 'merge'
      }
    );
  }

  filterContentTypeData(page: any = {}) {
    if (page?.page) {
      this.currentPage = page?.page;
    }
    this.router.navigate(['/contents'], {
        queryParams: {
          ...this.queryParams,
          page: this.currentPage,
          content_type: this.filter.value.content_type
        },
        queryParamsHandling: 'merge'
      }
    );
  }

  filterStatusData(page: any = {}) {
    if (page?.page) {
      this.currentPage = page?.page;
    }
    this.router.navigate(['/contents'], {
        queryParams: {
          ...this.queryParams,
          page: this.currentPage,
          status: this.filter.value.status
        },
        queryParamsHandling: 'merge'
      }
    );
  }

  updateStatus(id: string, value: any) {
    const modelRef = this.modelService.show(UpdateContentStatusComponent, {
      keyboard: true,
      animated: true,
      ignoreBackdropClick: false,
      class: 'modal-md modal-dialog-centered custom-model confirmation'
    });
    modelRef.content.isActive = value;

    modelRef.content.closeEvent.subscribe((result: any) => {
      if (result) {
        this.isStatusAction = true;
        this.adminStore.dispatch(UpdateContentStatus({
          body: {
            content_id: id,
            status: value,
            content_type: this.filter.value.content_type
          }
        }));
      }
    });
  }

  getAllTransaction = (page = 0, perPage = 10, search = '', order = {
    filterBy: 'streams',
    filterType: 'desc'
  }) => {
    // if (this.sort.field === order.filterBy) {
    //   this.sort = {field: order.filterBy, dir: order.filterType};
    // } else {
    //   this.sort = {field: order.filterBy, dir: order.filterType};
    // }
    this.router.navigate(['/contents'], {
        queryParams: {
          page,
          limit: perPage,
          search,
          // ...order,
          monthRange: this.filter.value.monthRange,
          content_type: this.filter.value.content_type,
          status: this.filter.value.status
          // sort: JSON.stringify(this.sort),
          // otherType: true
        },
        queryParamsHandling: 'merge'
      }
    );
  };

  callApi() {
    this.adminStore.dispatch(ContentsList({
      params: {
        page: this.queryParams.page,
        limit: this.queryParams.limit,
        search: this.queryParams.search,
        date: this.queryParams.monthRange,
        content_type: this.queryParams.content_type,
        status: this.queryParams.status
        // sort: this.queryParams.sort,
        // otherType: true
      }
    }));
  }

  getCurrentUser(event: any) {
    this.currentUser = event;
  }

  redirectBack() {
    history.back();
  }
}
